import React from 'react';
import { BrowserRouter as Router, Route, Routes } from 'react-router-dom';
import RepFinderPage from './pages/RepFinderPage/RepFinderPage';
// import { useUser } from './context/user-context';
// import { useConfig } from './context/config-context';

// import RequestsPage from './pages/RequestsPage/RequestsPage';
// import RequestProfilePage from './pages/RequestProfilePage/RequestProfilePage';
// import RequestEditHistoryPage from './pages/RequestEditHistoryPage/RequestEditHistoryPage';
import ErrorPage404 from './pages/ErrorPage404';
import { library } from '@fortawesome/fontawesome-svg-core';
import { faMagnifyingGlass, faEnvelope, faPhoneFlip } from '@fortawesome/free-solid-svg-icons';

// import SessionDialog from './components/Dialogs/SessionDialog';
// import UserConfirmationDialog from './components/Dialogs/UserConfirmationDialog';

// import { Loader } from '@progress/kendo-react-indicators';

library.add(faMagnifyingGlass, faEnvelope, faPhoneFlip);

const App = () => {
  // const userInfo = useUser().state.user;
  // const config = useConfig().state.config;

  return (
    <div className="app">
      <Router
        basename="/aem"
        // getUserConfirmation={(message, callback) =>
        //   UserConfirmationDialog(message, callback)
        // }
      >
        <Routes>
          <Route path="/repfinder" exact element={<RepFinderPage/>} />
          {/* <Route path="/profile/:id" component={RequestProfilePage} />
          <Route path="/edit-history/:id" component={RequestEditHistoryPage} /> */}
          <Route element={<ErrorPage404/>} />
        </Routes>
      </Router>
{/* 
      <SessionDialog /> */}
    </div>
  )
};

export default App;
